<template>
  <div class="layout-col">
    <section class="-wrapper-tile -wrapper-column fitting- -border-radius-1">
      <div class="-header">
        <div class="-wrapper-column">
          <p class="-h2 -font-weight-medium">{{ $t('pages_contract_ContractInfo.trend') }}</p>
        </div>
        <div class="-wrapper v-center-">
          <span-dropdown
            id="contract-detail-chart-select-month"
            value="6"
            class="custom-select mr-2"
            @selected="onSelected"
          >
            <g-dropdown-item-wrap class="-width-100 -bg-white -box-shadow-level-4">
              <g-dropdown-item value="3" text="Last 3 Months" ></g-dropdown-item>
              <g-dropdown-item value="6" text="Last 6 Months" ></g-dropdown-item>
              <g-dropdown-item value="9" text="Last 9 Months" ></g-dropdown-item>
              <g-dropdown-item value="12" text="Last 12 Months" ></g-dropdown-item>
            </g-dropdown-item-wrap>
          </span-dropdown>
          <div class="-toggle-button -ml-2">
            <button type="button" id="contract-detail-chart-stack"
                    name="button" :class="{'selected-': isEqulizer}" @click="onToggleIsLineGraph(false)">
              <span class="material-icons">equalizer</span>
            </button>
            <button type="button" id="contract-detail-chart-line"
                    name="button" :class="{'selected-': isTimeline}" @click="onToggleIsLineGraph(true)">
              <span class="material-icons">timeline</span>
            </button>
          </div>
        </div>
      </div>
      <div  class="-bg-white -wrapper-h-v-center" style="height:300px;">

        <am-xy-chart-2
          id="contract-detail-chart"
          refName="contractInfoDetailCostChart"
          :series-type="seriesType"
          :chart-data="contractDetailChartData"
          :filter="contractDetailSeriesList"
          :stacked="true"
          :mouse-cursor-style="MOUSE_CURSOR.default"
        />
      </div>
    </section>
  </div>
</template>

<script>


import AmXyChart2 from '../../components/AmXyChart2'
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import {MOUSE_CURSOR} from '@/code/CodeChart'
import moment from 'moment';
import {mapActions, mapGetters} from "vuex";
import {AUTH_GROUP} from "@/constants/constants";
import SpanDropdown from './components/SpanDropdown'

am4core.useTheme(am4themes_animated);
export default {
  name: 'Contract-Info-Cost-TrendMonth',
  components: {
    AmXyChart2,
    [SpanDropdown.name]: SpanDropdown
  },
  props : {
    billMonth : {
      type : Object,
      default :()=> {}
    }

  },
  data () {
    return {
      chartData: [],
      seriesList: [],
      isLineGraph: false,
      monthParam : 6,
      MOUSE_CURSOR: MOUSE_CURSOR,
    }
  },

  computed : {
    ...mapGetters('user', ['userInfo']),
    ...mapGetters('contract', ['contractDetailChartData','contractDetailSeriesList','contractDetail']),

    isEqulizer () {
      return !this.isLineGraph
    },
    isTimeline () {
      return this.isLineGraph
    },
    seriesType () {
      return this.isLineGraph ? 'LineSeries' : 'ColumnSeries'
    }
  },
  methods: {

    ...mapActions('contract', ['getContractsGetChartDataWithId']),
    onSelected (id) {

      this.monthParam = id.value;
      this.getInit(this.monthParam)

    },
    async getInit(){

      let date = new Date();

      let param = {};

      param.companyCode = this.userInfo.companyCode;

      if (this.userInfo.auth === AUTH_GROUP.BespinSales)  {
        param.empNo = this.userInfo.empNo;
      }else{
        param.empNo = '';
      }
      if(this.monthParam === ''){
        param.startMonth = moment(date.getTime()).add("-6", "M").format("YYYYMM")

      }else{
        let month = "-"+(parseInt(this.monthParam)-1);
        param.startMonth = moment(this.billMonth.month).add(month, "M").format("YYYYMM")

      }
      param.endMonth = this.billMonth.month
      param.id = this.$route.query.id

      await this.getContractsGetChartDataWithId(param);


    },
    onToggleIsLineGraph (isLineGraph) {
      this.isLineGraph = isLineGraph
    }

  },

  async beforeMount () {

  },
  watch: {
    billMonth :  {
      handler(value){

        this.getInit(value.monthParam);

      },
      deep: true,
      immediate : true

    }
  },
}
</script>






// WEBPACK FOOTER //
// src/pages/contract/components/ContractDetailCostTrendMonth.vue